import { Node_Type } from "./../../../ricos-schema/next-schema/index.js";
const toFullscreenDocument = (content) => content;
const isFullscreenExpandableNode = (node) => node.type === Node_Type.IMAGE || node.type === Node_Type.GALLERY;
export {
  isFullscreenExpandableNode,
  toFullscreenDocument
};
//# sourceMappingURL=to-fullscreen-document.js.map
